import { useNavigate } from 'react-router-dom';
import { getExaminationList } from '../../../core';
import { CustomLoader } from '../../../components/basic/loader';
import UserFileImage from '../../../assets/icons/my_documents_2.svg';
import backgroundImage from '../../../assets/icons/doc_bg.png';
import { FofLogin } from '../../../components/basic/fof-login';
import { useUser } from '../../../contexts/user';
import { useInView } from 'react-intersection-observer';
import { useCallback, useEffect, useState } from 'react';

export const ExaminationList = () => {
  const { user } = useUser();
  const { ref, inView } = useInView();
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [lastPage, setLastPage] = useState(1000);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [data, setData] = useState<any>([]);
  const [loading, setLoading] = useState(true); // should befalse
  // const examinations = useQuery({
  //   queryKey: ['examination-list', 1],
  //   queryFn: async () => {
  //     const res = await getExaminationList(1);
  //     return res.data.data;
  //   }
  // });

  const fetchNextPage = useCallback(async () => {
    if (lastPage < page) return;
    if (page) console.log('heree');
    setLoading(true);
    try {
      const res = await getExaminationList(page);
      if (res.status === 200) {
        setLastPage(res.data.last_page);
        setPage((pre) => pre + 1);
        console.log(res.data.data);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        // setData(res.data.data);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        setData((pre: any) => {
          return [...pre, ...res.data.data];
        });
      }
    } catch (e) {
      console.log(e);
    }
    setLoading(false);
  }, [page]);

  useEffect(() => {
    if (inView || page === 1) {
      fetchNextPage();
    }
  }, [inView, lastPage, page, data]);

  if (!user.isLoggedIn) {
    return (
      <FofLogin
        startFromTop={true}
        image={UserFileImage}
        text="در این قسمت شما میتوانید معاینه های ذخیره شده و ویدیو های توصیه درمانی ذخیره شده خود را ببینید."
        redirect="/expertise"
      />
    );
  }
  return (
    <div className="py-5 px-5">
      <p className="text-justify mb-4">
        روند تشخیص شما در این بخش بر اساس تاریخ انجام، ذخیره شده اند. با انتخاب هر کدام از روند های
        خود می توانید به ویدیو های آموزشی آن بخش دسترسی داشته باشید.
      </p>
      {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
      {data?.map((result: any) => {
        return (
          <div
            key={result.id}
            className="shadow-lg rounded-lg px-5 py-3 flex cursor-pointer mb-3 relative overflow-hidden"
            onClick={() => navigate(`/diagnosis/${result.id}/${result.product_id}`)}>
            <img
              src={backgroundImage}
              alt=""
              style={{
                position: 'absolute',
                width: '100%',
                height: '112%',
                left: 0,
                top: '-5%',
                zIndex: -1
              }}
            />
            <div className="flex flex-col w-full">
              <p className="text-base text-[--rs-gray-700]">روند تشخیصی: {result.product_name}</p>
              <p className="text-sm text-justify">
                نتیجه تشخیص: {JSON.parse(result.end_result_vertex ?? '{}')?.questionLabel}
              </p>
              <p className="text-xs text-left">
                انجام شده در تاریخ :{' '}
                {result?.created_at
                  ? new Intl.DateTimeFormat('fa-IR', {
                      weekday: 'long',
                      year: 'numeric',
                      month: 'numeric',
                      day: 'numeric'
                    }).format(new Date(result?.created_at))
                  : null}
              </p>
            </div>
          </div>
        );
      })}

      {loading ? <CustomLoader /> : <button ref={ref} onClick={() => fetchNextPage()}></button>}
    </div>
  );
};
